// apps/client_diy_webapp/src/pages/qualitative-surveys/components/StatusBadge.jsx
import React from "react";

const STATUS_CONFIG = {
    draft: { label: "Draft", color: "bg-gray-100 text-gray-600 border-gray-200" },
    submitted_for_review: { label: "In Review", color: "bg-blue-50 text-blue-700 border-blue-200" },
    feasibility_review: { label: "Feasibility Review", color: "bg-indigo-50 text-indigo-700 border-indigo-200" },
    changes_requested: { label: "Changes Requested", color: "bg-amber-50 text-amber-700 border-amber-200" },
    approved: { label: "Approved", color: "bg-green-50 text-green-700 border-green-200" },
    not_feasible: { label: "Not Feasible", color: "bg-red-50 text-red-700 border-red-200" },
    live: { label: "Live", color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
    recruiting: { label: "Recruiting", color: "bg-teal-50 text-teal-700 border-teal-200" },
    participant_review: { label: "Participant Review", color: "bg-cyan-50 text-cyan-700 border-cyan-200" },
    scheduling: { label: "Scheduling", color: "bg-sky-50 text-sky-700 border-sky-200" },
    fieldwork_in_progress: { label: "Fieldwork In Progress", color: "bg-violet-50 text-violet-700 border-violet-200" },
    completed: { label: "Completed", color: "bg-green-100 text-green-800 border-green-300" },
    closed: { label: "Closed", color: "bg-gray-200 text-gray-700 border-gray-300" },
    paused: { label: "Paused", color: "bg-orange-50 text-orange-700 border-orange-200" },
    cancelled: { label: "Cancelled", color: "bg-red-100 text-red-700 border-red-200" },
};

export default function StatusBadge({ status, className = "" }) {
    const config = STATUS_CONFIG[status] ?? { label: status ?? "Unknown", color: "bg-gray-100 text-gray-500 border-gray-200" };
    return (
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold border ${config.color} ${className}`}>
            <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
            {config.label}
        </span>
    );
}